export default (props, vars) => !props?.['showPresentations'];
